import { z } from "zod";
import { webhookEventSchema } from "./webhook-event.js";

export const createWebhookSchema = z
	.object({
		name: z.string().trim().min(1, { message: "Name is required" }).max(120, { message: "Name must be at most 120 characters" }),
		url: z.url({ message: "URL must be a valid URL" }).refine((value) => value.startsWith("https://"), { message: "URL must use HTTPS" }),
		events: z.array(webhookEventSchema).min(1, { message: "Select at least one event" }),
		is_active: z.boolean().optional(),
	})
	.strict();

export type CreateWebhookPayload = z.infer<typeof createWebhookSchema>;

export interface CreateWebhookResponse {
	id: string;
	name: string;
	url: string;
	events: CreateWebhookPayload["events"];
	secret_prefix: string;
	plain_secret: string;
	is_active: boolean;
	created_at: string;
}
